export enum AUTH_STATUS {
  NOT_DETERMINED,
  GUEST,
  LOGGED_IN,
}

export const NUPI_CONFIG = 'nykaaUniversalProfileImport';